/**
 * Application pathname with Vite `base` stripped (e.g. `/exxat-home` on GitHub Pages).
 */
export function appPathname(
  pathname = typeof window !== "undefined" ? window.location.pathname : "/",
): string {
  const base = import.meta.env.BASE_URL
  if (base === "/") return pathname

  const prefix = base.replace(/\/$/, "")
  if (pathname === prefix || pathname === `${prefix}/`) return "/"
  if (pathname.startsWith(`${prefix}/`)) {
    return pathname.slice(prefix.length) || "/"
  }
  return pathname
}
